import type { IUsersApiUserInList } from '../../redux/api/users/users-api.types';
import { ICommunity } from '../../types/interfaces/community';
import { IUser } from '../../types/interfaces/user';

type UserLike = IUser | IUsersApiUserInList;

/** `user.subscriptions`: each item has `toUser` filled for user subscriptions. */
export function usersFromSubscriptionRelations(
  relations: Array<{ toUser?: UserLike }> | undefined,
): IUser[] {
  if (!relations?.length) {
    return [];
  }
  return relations.map((r) => r.toUser).filter(Boolean) as IUser[];
}

/** `user.subscribers`: each item has `user` filled (the subscriber). */
export function usersFromSubscriberRelations(
  relations: Array<{ user?: UserLike }> | undefined,
): IUser[] {
  if (!relations?.length) {
    return [];
  }
  return relations.map((r) => r.user).filter(Boolean) as IUser[];
}

/** `user.communitySubscriptions`: each item has `toCommunity` filled. */
export function communitiesFromCommunitySubscriptionRelations(
  relations: Array<{ toCommunity?: ICommunity }> | undefined,
): ICommunity[] {
  if (!relations?.length) {
    return [];
  }
  return relations
    .map((r) => r.toCommunity)
    .filter((c): c is ICommunity => !!c);
}
